export function FormTextarea({register,errors,id,labelText,rules,disabled=false,placeholder="",labelClass="",rows=5,cols=30,divclass,areaClass,value}){
    return (
        <div className={`${divclass} custom-input`}>
            {
                labelText ? <label htmlFor={id} className={`form-label ${labelClass}`}>{labelText}</label>
                :<></>
            }
            
                
                <textarea
                  placeholder={placeholder}
                  disabled={disabled}
                  id={id}
                  rows={rows}
                  cols={cols}
                  {...register(id,rules)}
                  className={`p-inputtextarea p-inputtext p-component`+` ${areaClass}` +` ${errors[id] && 'p-invalid'}`}
                  value={value}
                ></textarea>
                 
                {errors[id] && (
                  <small className='p-error'>{errors?.[id]?.message}</small>
                )}
               
        </div>
        )
}
